<script>
export default {
    props: {
        title: String,
        options: Array,
    },
    methods: {
        setOrderBy(value) {
            this.$set(this.facetFilter.filter, 'orderBy', value);

            this.facetFilter.searchAgain();
        }
    },
    computed: {
        hasOptions() {
            return this.options.length > 0;
        },
        facetFilter() {
            return this.$parent;
        },
        selected: {
            get() {
                return this.facetFilter.filter.orderBy;
            },
            set(value) {
                this.setOrderBy(value);
            }
        }
    }
}
</script>

<template>
    <div class="row" v-if="hasOptions">
        <div class="col-sm-4">
            <h5 class="lh-34" style="margin: 0;">{{ title }}</h5>
        </div>
        <div class="col-sm-8">
            <select class="form-control" v-model="selected">
                <option value=""></option>
                <option :value="option.value" v-for="option in options">{{ option.label }}</option>
            </select>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <hr class="hr-line-dashed">
            </div>
        </div>
    </div>
</template>
